import { decodeJwtBody } from "@maersk-global/shared-js";

export const storeDataInLS = (key, data, ttlMinutes) => {
  const now = new Date().getTime();
  const item = {
    data,
    expiry: now + ttlMinutes * 60 * 1000 // Convert minutes to milliseconds
  };
  localStorage.setItem(key, JSON.stringify(item));
};

// Function to retrieve data and check expiration
export const getDataFromLS = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date().getTime();

  if (now > item.expiry) {
    localStorage.removeItem(key);
    return null; // Data has expired
  }
  return item.data;
};

export const getJwtToken = (tokenType = "id_token") => {
  let token: any;

  for (const [key, value] of Object.entries(localStorage)) {
    if (key.includes(`.${tokenType}`)) {
      token = value;
    }
  }
  // tokenType = id_token -> localStorage.getItem("al.https://accounts-cdt.apmterminals.com/root-cdt.apmt001.id_token");
  // tokenType = access_token -> localStorage.getItem("al.https://accounts-cdt.apmterminals.com/root-cdt.apmt001.access_token");
  return token;
};

export const isAuthenticatedUser = (): boolean => {
  const jwt = getJwtToken("access_token");
  const decodedJwt: any = decodeJwtBody(jwt);
  return !decodedJwt?.error && decodedJwt?.exp >= Date.now() / 1000;
};

export const clearLocalStorageData = (): void => {
  localStorage.removeItem("saveContainerTerminal");
  localStorage.removeItem("selectedContainers");
  localStorage.removeItem("terminalNav");
  localStorage.removeItem("containerNumbers");
};

export const checkDeviceType = () => {
  // Check if the device is a desktop/laptop
  if (/desktop|pc/i.test(navigator.userAgent)) {
    return "You are using a desktop or laptop.";
  }

  // Check if the device is a tablet
  if (/tablet/i.test(navigator.userAgent)) {
    return "You are using a tablet.";
  }

  // Check if the device is a mobile phone
  if (/mobile/i.test(navigator.userAgent)) {
    return "You are using a mobile phone.";
  }

  // Check if the device is running iOS
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    return "You are using an iOS device.";
  }

  // Check if the device is running Android
  if (/Android/.test(navigator.userAgent)) {
    return "You are using an Android device.";
  }

  // Check if the device is a Mac
  if (navigator.platform.toUpperCase().indexOf("MAC") >= 0) {
    return "You are using a Mac.";
  }

  // Check if the device is a Windows PC
  if (navigator.platform.toUpperCase().indexOf("WIN") >= 0) {
    return "You are using a Windows PC.";
  }
};
